import { render, staticRenderFns } from "./FormDetailsMobileView.vue?vue&type=template&id=a21a6d20"
import script from "./FormDetailsMobileView.vue?vue&type=script&lang=js"
export * from "./FormDetailsMobileView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports